/**
 * Picks which boot-critical resource the user is currently waiting on, so the
 * splash retry state can show a specific "Loading countries…" hint instead of a
 * blank spinner. Pure + ordered by the sequence the app needs them in
 * (account → products → countries → balances). Returns "finalizing" once every
 * fetch has resolved (the brief window before the app paints).
 */
export type BootProgressKey =
  | "account"
  | "products"
  | "countries"
  | "balances"
  | "finalizing";

export interface BootProgressSignals {
  isAccountReady: boolean;
  isProductsReady: boolean;
  isCountriesReady: boolean;
  isBalancesReady: boolean;
}

export function resolveBootProgressKey({
  isAccountReady,
  isProductsReady,
  isCountriesReady,
  isBalancesReady,
}: BootProgressSignals): BootProgressKey {
  if (!isAccountReady) return "account";
  if (!isProductsReady) return "products";
  if (!isCountriesReady) return "countries";
  if (!isBalancesReady) return "balances";
  return "finalizing";
}
